import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Contact from "./components/Contact";
import Projects from "./components/Projects";
import Preloader from "./Preloader";
import { useState} from "react";
import Experience from "./components/Experience";


function App() {
  const [loading, setLoading] = useState(true);

  const handlePreloaderComplete = () => {
    document.querySelector('.preloader').classList.add('hidden');
    setTimeout(() => setLoading(false), 500); // Wait for animation to finish
};



return (
  <>
    {loading ? (
      <Preloader onComplete={handlePreloaderComplete} />
    ) : (
      <div className="absolute inset-0 -z-10 h-auto w-full bg-white overflow-x-hidden bg-fixed bg-[linear-gradient(to_right,#f0f0f0_1px,transparent_1px),linear-gradient(to_bottom,#f0f0f0_1px,transparent_1px)] bg-[size:6rem_4rem]">
        <div className="absolute inset-0 overflow-x-hidden bg-fixed bg-[radial-gradient(circle_800px_at_100%_200px,#d5c5ff,transparent)] px-10">
          <Navbar />
          <main>
            <Hero />
            <Experience />
            <Projects />
            <Contact/>
          </main>
        </div>
        
      </div>
    )}
  </>
);


};

export default App;
